'use strict';/* global define:false, console:false */define('modules/feedback/services/feedback-periods/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
      service.$inject = ["FeedbackProcesses", "$filter"];
function service(FeedbackProcesses,$filter){// jshint validthis:true
// jshint latedef:false
var dateFilter=$filter('date');this.addOneDay=addOneDay;this.getFeedbackStatusClassName=getFeedbackStatusClassName;this.markAsMet=setMetStatus.bind(this,FeedbackProcesses,true);// ---
/**
     * Calculate the start date of the next feedback period by adding one day
     * to the end of the prevoius period
     *
     * @param  {String} dateString - End date of the current feedback period
     *
     * @return {Object}            - Date object result
     *
     * @tested
     */function addOneDay(dateString){var date=new Date(dateString);return dateFilter(date.setDate(date.getDate()+1));}/**
     * Get the feedback status class name
     *
     * @param  {String} feedbackStatus - Feedback status
     *
     * @return {String}                - Feedback status class name
     *
     * @tested
     */function getFeedbackStatusClassName(feedbackStatus){return feedbackStatus.replace(/_/g,'-').toLowerCase();}/**
      * Set met status
      *
      * @param {Object} FeedbackProcesses - Feedback processes service
      * @param {Boolean} met              - Met or not
      * @param {Number} periodId          - Feedback processes id
      */function setMetStatus(FeedbackProcesses,met,periodId){return FeedbackProcesses.update({id:periodId},{met:met});}}module.exports=service;});
